<section id="societe" class="container-company">
  <h2>Société</h2>
  <!-- <div class="company-grid">
    <div class="profil">
      <div class="card transparent-bg"><img src="https://thispersondoesnotexist.com/image" alt=""></div>
      <div class="profil-content">
        <div class="name">Samuel Bailey</div>
        <div class="role">CEO</div>
      </div>
    </div>
    <div class="profil">
      <div class="card transparent-bg"><img src="https://thispersondoesnotexist.com/image" alt=""></div>
      <div class="profil-content">
        <div class="name">Jennifer Smith</div>
        <div class="role">Associée</div>
      </div>
    </div>
    <div class="profil">
      <div class="card transparent-bg"><img src="https://thispersondoesnotexist.com/image" alt=""></div>
      <div class="profil-content">
        <div class="name">Jason Thompson</div>
        <div class="role">Associée</div>
      </div>
    </div>
    <div class="profil">
      <div class="card transparent-bg"><img src="https://thispersondoesnotexist.com/image" alt=""></div>
      <div class="profil-content">
        <div class="name">Christopher Rogers</div>
        <div class="role">Associée</div>
      </div>
    </div> -->
  <div class="card transparent-bg details">
    <h3>Qui sommes-nous ?</h3>
    <p><strong>CAPCOD</strong></p>
    <p>
      Au service de votre efficacité, nous concevons et réalisons des applications métiers au service de votre agilité : des logiciels
      adaptés à votre entreprise, vos enjeux, vos utilisateurs et votre secteur d'activité.
    </p>
    <p><a href="https://www.capcod.eu" target="_blank">www.capcod.eu</a><br /><br /></p>
    <p><strong>ELLIPSE AVOCATS STRASBOURG</strong></p>
    <p>
      Spécialisé en droit du travail et des relations sociales, Ellipse Avocats propose une alternative qualitative sur le plan technique et
      de la relation client, basée sur une dynamique de développement durable.
    </p>
    <p><a href="https://www.ellipse-avocats.com/" target="_blank">www.ellipse-avocats.com</a><br /><br /></p>
    <p><strong>FRANCOIS DE CHIARA</strong></p>
    <p>
      Conseil en Transformation et Management de Système d’Information, François met ses 30 ans d'expérience, au service des dirigeants de
      tous type d’organisations (entreprises, collectivités…) sous forme de conseil en matière d’alignement stratégique, d’évolution et de
      gouvernance des systèmes d’information et d’accompagnement et pilotage des projets de transformation.
    </p>
    <p><a href="https://fdechiara-conseil.fr/" target="_blank">www.fdechiara-conseil.fr</a><br /><br /></p>
  </div>
  <!-- </div> -->
</section>
